import jQuery from 'jquery';

const NODE_ENV = process.env.NODE_ENV;
if (NODE_ENV !== 'production' || (!window.jQuery && !window.$)) {
  window.jQuery = jQuery;
  window.$ = jQuery;
}

